import script from "./DigitalSignatureForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./DigitalSignatureForm.vue?vue&type=script&setup=true&lang=ts"

import "./DigitalSignatureForm.vue?vue&type=style&index=0&id=c04693a8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c04693a8"]])

export default __exports__